import { useTranslation } from "@bounce/i18n"

export const useAnonymousUserName = () => {
  const { t } = useTranslation("store")

  return t("cmp.storeReviews.traveler", "Traveler")
}
